export const supportEmail = 'soporte@sora.mx';
